export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://u439lq97h7.execute-api.us-west-2.amazonaws.com/dev";

export const ANALYTICS_API_BASE_URL =
  process.env.REACT_APP_ANALYTICS_API_BASE_URL ||
  "https://n94ehpdck1.execute-api.us-west-2.amazonaws.com/dev";

export const OPTIMIZED_API_BASE_URL =
  process.env.REACT_APP_OPTIMIZED_API_BASE_URL ||
  ANALYTICS_API_BASE_URL;

export const apiUrl = (path) =>
  `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;

export const analyticsApiUrl = (path) =>
  `${ANALYTICS_API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;

export const optimizedApiUrl = (path) =>
  `${OPTIMIZED_API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;

export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "427900093015-1urbib8l4u4sple6ssktl65tqln3oedf.apps.googleusercontent.com";

export const GITHUB_CLIENT_ID =
  process.env.REACT_APP_GITHUB_CLIENT_ID || "85fd6558c80338e7c383";
